(ns common.schema.entities.ai-summary-configuration.options)

(def access-level-private
  :ai-summary-configuration.access-level/private)

(def access-level-restricted
  :ai-summary-configuration.access-level/restricted)

(def access-level-all-users
  :ai-summary-configuration.access-level/all-users)

(def access-level-options
  [{:key access-level-private
    :value access-level-private
    :label "Private"}
   {:key access-level-restricted
    :value access-level-restricted
    :label "Selected users and teams"}
   {:key access-level-all-users
    :value access-level-all-users
    :label "All users"}])

(def style-guideline-source-none
  :ai-summary-configuration.style-guideline-source/none)

(def style-guideline-source-document
  :ai-summary-configuration.style-guideline-source/document)

(def style-guideline-source-url
  :ai-summary-configuration.style-guideline-source/url)

(def style-guideline-source-options
  [{:key style-guideline-source-none
    :value style-guideline-source-none
    :label "No style guidelines"}
   {:key style-guideline-source-document
    :value style-guideline-source-document
    :label "Style guideline document"}
   {:key style-guideline-source-url
    :value style-guideline-source-url
    :label "Style guideline URL"}])

(def data-source-deal-fields
  :ai-summary-configuration.data-source/deal-fields)

(def data-source-deal-attachments
  :ai-summary-configuration.data-source/deal-attachments)

(def data-source-deal-activities
  :ai-summary-configuration.data-source/deal-activities)

(def data-source-deal-linked-persons
  :ai-summary-configuration.data-source/deal-linked-persons)

(def data-source-target-fields
  :ai-summary-configuration.data-source/target-fields)

(def data-source-target-attachments
  :ai-summary-configuration.data-source/target-attachments)

(def data-source-target-activities
  :ai-summary-configuration.data-source/target-activities)

(def data-source-target-linked-persons
  :ai-summary-configuration.data-source/target-linked-persons)

(def data-source-target-investor-profile-fields
  :ai-summary-configuration.data-source/target-investor-profile-fields)

(def data-source-target-investor-profile-attachments
  :ai-summary-configuration.data-source/target-investor-profile-attachments)

(def data-source-target-investor-profile-activities
  :ai-summary-configuration.data-source/target-investor-profile-activities)

(def data-source-target-investor-profile-linked-persons
  :ai-summary-configuration.data-source/target-investor-profile-linked-persons)

(def data-source-options
  [{:key data-source-deal-fields
    :value data-source-deal-fields
    :label "Deal fields"}
   {:key data-source-deal-attachments
    :value data-source-deal-attachments
    :label "Deal attachments"}
   {:key data-source-deal-activities
    :value data-source-deal-activities
    :label "Deal activity timeline"}
   {:key data-source-deal-linked-persons
    :value data-source-deal-linked-persons
    :label "Deal linked persons"}
   {:key data-source-target-fields
    :value data-source-target-fields
    :label "Target asset fields"}
   {:key data-source-target-attachments
    :value data-source-target-attachments
    :label "Target asset attachments"}
   {:key data-source-target-activities
    :value data-source-target-activities
    :label "Target asset activity timeline"}
   {:key data-source-target-linked-persons
    :value data-source-target-linked-persons
    :label "Target asset linked persons"}
   {:key data-source-target-investor-profile-fields
    :value data-source-target-investor-profile-fields
    :label "Target investor profile fields"}
   {:key data-source-target-investor-profile-attachments
    :value data-source-target-investor-profile-attachments
    :label "Target investor profile attachments"}
   {:key data-source-target-investor-profile-activities
    :value data-source-target-investor-profile-activities
    :label "Target investor profile activity timeline"}
   {:key data-source-target-investor-profile-linked-persons
    :value data-source-target-investor-profile-linked-persons
    :label "Target investor profile linked persons"}])

(def default-data-sources
  (mapv :value data-source-options))
